/* tslint:disable */
/* tslint:disable */
/**
 * ClearFlask Admin API
 * ClearFlask API documentation.
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/* tslint:disable */
// eslint-disable-next-line no-unused-vars
import { exists } from '../runtime';
// eslint-disable-next-line no-unused-vars
import {
    HistogramResponsePoints,
    HistogramResponsePointsFromJSON,
    HistogramResponsePointsToJSON,
    Hits,
    HitsFromJSON,
    HitsToJSON,
} from './';

/**
 * 
 * @export
 * @interface HistogramResponse
 */
export interface HistogramResponse {
    /**
     * 
     * @type {Array<HistogramResponsePoints>}
     * @memberof HistogramResponse
     */
    points: Array<HistogramResponsePoints>;
    /**
     * 
     * @type {Hits}
     * @memberof HistogramResponse
     */
    hits: Hits;
}

export function HistogramResponseFromJSON(json: any): HistogramResponse {
    return {
        
        'points': (json['points'] as Array<any>).map(HistogramResponsePointsFromJSON),
        
        
        'hits': HitsFromJSON(json['hits']),
    };
}

export function HistogramResponseToJSON(value?: HistogramResponse): any {
    if (value === undefined) {
        return undefined;
    }
    return {
        
        'points': (value.points as Array<any>).map(HistogramResponsePointsToJSON),
        
        
        'hits': HitsToJSON(value.hits),
    };
}


